import React from "react";

const ExpandCollapseIcon = ({ expand, toggleExpanded, index }) => {
  return (
    <>
      {!expand ? (
        <svg
          width="24"
          height="24"
          onClick={() => toggleExpanded(index)}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 10L12 15L17 10"
            stroke="#5C5F62"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg
          width="24"
          height="24"
          onClick={() => toggleExpanded(index)}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 14L12 9L17 14"
            stroke="#5C5F62"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </>
  );
};

export default ExpandCollapseIcon;
